import { Endpoint } from '../endpoint';
import { AutomationWebhookId, AutomationWebhookResponse } from '@business/entities/automation_webhook';

export function fetchAutomationWebhooks() {
  return Endpoint.get<AutomationWebhookResponse[]>(`@gc/automation-webhook`);
}

export function createAutomationWebhook(webhook: Partial<AutomationWebhookResponse>) {
  const { delayMinutes, isEnabled, ...rest } = webhook;
  return Endpoint.post<AutomationWebhookResponse>(`@gc/automation-webhook`, {
    data: { ...rest, delay_minutes: delayMinutes, enabled: isEnabled },
  });
}

export function updateAutomationWebhook(id: AutomationWebhookId, webhook: Partial<AutomationWebhookResponse>) {
  const { delayMinutes, isEnabled, ...rest } = webhook;
  return Endpoint.patch<AutomationWebhookResponse>(`@gc/automation-webhook/${id}`, {
    data: { ...rest, delay_minutes: delayMinutes, enabled: isEnabled },
  });
}

export function toggleAutomationWebhook(id: AutomationWebhookId) {
  return Endpoint.patch<AutomationWebhookResponse>(`@gc/automation-webhook/toggle/${id}`);
}

export function deleteAutomationWebhook(id: AutomationWebhookId) {
  return Endpoint.delete<void>(`@gc/automation-webhook/${id}`);
}
